export default __webpack_public_path__ + "static/media/special-number-member.0d6e3545.svg";